import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import Swal from 'sweetalert2'

type Props = {
    showbutton: boolean
}

const SurveyInfo: React.FC<Props> = ({ showbutton }) => {
    const intl = useIntl()

    return (
        <>
            <div className='alert alert-danger d-flex align-items-center p-5 mb-10 mt-10 d-flex flex-column flex-md-row'>
                <div className='col-12 col-md-12'>
                    {intl.formatMessage({ id: 'SurveyInfoText' })}
                    {showbutton &&
                        <>
                            <br />
                            <a className="btn btn-success mt-5" href="https://kimlik.ege.edu.tr">
                               Tek Şifre İle Giriş Ekranına Dön
                            </a>
                        </>
                    }
                </div>
            </div>
        </>
    )
}

export { SurveyInfo }
